
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client-insurance-solution",
      function () {
        return require("private-next-pages/client-insurance-solution/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/client-insurance-solution"])
      });
    }
  